// extracted by mini-css-extract-plugin
export const footer = "AuthTemplateFooter-module--footer--1EJNk";